import store from '@/store/store'
import requestOutcomeMapper from '@/utils/request-outcome.mapper'
import chartLabels from '@/utils/chart-labels'

class OutcomeModule {

  initOutcomeList() {
    const legends = requestOutcomeMapper.getAllLegends()
    const outcomeList = legends.map(legend => {
      return {
        id: legend,
        name: chartLabels[legend].label,
        icon: 'chart-legend'
      }
    })

    store.commit('OUTCOME_LIST_SET', outcomeList)
  }

  initResolutionList() {
    const legends = requestOutcomeMapper.getAllLegends('assistanceResolutions')
    const resolutionList = legends.map(legend => {
      return {
        id: legend,
        name: chartLabels[legend].label,
        icon: 'chart-legend'
      }
    })

    store.commit('RESOLUTION_LIST_SET', resolutionList)
  }

  getOutcomeList() {
    return store.state.outcomeList
  }

  getResolutionList() {
    return store.state.resolutionList
  }
}

export default new OutcomeModule()
